import { deviceType } from "@tm/isomorphic-utils";
import styled from "styled-components";

import { theme } from "@tm/utility/global";

export const InterlinkingBlockStyle = styled.section`
  background: ${theme.whiteText};
  color: ${theme.blackText};
  padding: 20px 0;
  width: 100%;
`;

export const InterlinkingBlockWrap = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 20px;

  @media screen and ${deviceType.mobile} {
    padding: 0 16px;
  }
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  & > *:last-child {
    gap: 0;
  }

  @media screen and ${deviceType.mobile} {
    gap: 30px;

    & > *:last-child {
      gap: 0;
    }
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.h3`
  color: ${theme.blackText};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.4;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media screen and ${deviceType.mobile} {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

export const LinksContainer = styled.div`
  line-height: 1.6;
  text-align: justify;
`;

export const LinkItem = styled.span`
  &:not(:last-child):after {
    content: ", ";
    color: ${theme.blackText};
  }
`;

export const Link = styled.a`
  color: ${theme.blackText};
  text-decoration: none;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.blackText || "#007bff"};
    text-decoration: underline;
  }

  @media screen and ${deviceType.mobile} {
    font-size: 12px;
  }
`;
